<forge-card class="chart" no-padding>
    <forge-toolbar>
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            @if (isLoaded && !errorMessage) {
            <div fxLayout="row" fxLayoutAlign="start center">
                <span class="forge-typography--subheading1">{{ProjectLabel}}</span>
            </div>
            }
        </div>

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0" aria-haspopup="true"
            telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        @if (!isLoaded) {
        <busy-indicator [chart]="true"></busy-indicator>
        }
        @if (isLoaded && chartHasData) {
        <account-detail-card fxFlex="auto" [chartHasData]="chartHasData" [totals]="chartData" index="2">
        </account-detail-card>
        }

        @if (!chartHasData) {
        <div>
            Not enough data to display breakdown
        </div>
        }

        @if (errorMessage) {
        <div class="error-red">{{errorMessage}}</div>
        }
    </div>
</forge-card>